/*----------------------------------
- NAV CLICK CONTRACT
----------------------------------*/

/**
 * @docs docs/features/website-navigation-shell
 *
 * The shape every shell menu reports a followed link with, and the one id the screener button
 * shares across surfaces. `Header` is the single emitter of `landing_nav_click`.
 */

/*----------------------------------
- TYPES
----------------------------------*/

/** Which part of the shell a `landing_nav_click` came from: the bar itself, one desktop panel, or the phone menu. */
export type LandingNavMenu = 'bar' | 'domains' | 'market' | 'tools' | 'mobile';

/** The surface that rendered the link, coarser than `menu`: the three desktop panels share `megamenu`. */
export type LandingNavSurface = 'header' | 'megamenu' | 'mobile_menu';

/**
 * What a menu calls when a visitor follows one of its links. The menu knows only which
 * item and where it leads; `Header` binds the menu and surface, so a panel cannot report
 * itself under the wrong one. `item` is the catalog id when the row has one, else its label.
 */
export type MenuNavigateHandler = (item: string, href: string) => void;

/*----------------------------------
- CONSTANTS
----------------------------------*/

/**
 * The screener button carries no catalog id, and its label differs between the desktop
 * panel and the phone menu, so both report this one id to be counted as one destination.
 */
export const NAV_SCREENER_ITEM = 'open-screener';
